export var FormSteps;
(function (FormSteps) {
    FormSteps["VALIDATE"] = "validate";
    FormSteps["REGISTER"] = "register";
})(FormSteps || (FormSteps = {}));
export var Screen;
(function (Screen) {
    Screen["FORM"] = "form";
    Screen["SUCCESS"] = "success";
})(Screen || (Screen = {}));
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["SELLER_NOT_FOUND"] = "seller-not-found";
    ErrorCodes["SELLER_NOT_FOUND_OR_IMPORTED"] = "seller-not-found-or-imported";
    ErrorCodes["USER_LOGIN_ALREADY_EXISTS"] = "user-login-already-exists";
    ErrorCodes["DUPLICATED_SELLER_ENROLMENT"] = "duplicated-seller-enrolment";
    ErrorCodes["USER_NOT_FOUND"] = "user-not-found";
})(ErrorCodes || (ErrorCodes = {}));
